export default {
  custom: () => import("E:/develop/集团官网/zzrb-gw/layouts/custom.vue").then(m => m.default || m),
  default: () => import("E:/develop/集团官网/zzrb-gw/layouts/default.vue").then(m => m.default || m)
}